/* Strong Padel: documented product facts, visual-only in the unpublished preview.
 * Contract: #spc-data.products[].productFacts + technicalRows[].displayValue.
 * No product writes, HTML description rewrite, commercial requests or SEO changes.
 * Manual rollback for QA: window.StrongProductSpecs.restore(); init() reapplies.
 */
(function () {
  'use strict';
  if (window.StrongProductSpecs) return;

  var DRAFT_THEME_ID = '189313384776';
  var mounted = null;
  var enabled = true;
  var observer = null;
  var pending = 0;
  var primaryKeys = new Set([
    'weight_g', 'weight_range_g', 'weight_tolerance_g', 'shape',
    'balance_category', 'face_material', 'frame_material',
    'core_material', 'thickness_mm', 'surface', 'feel', 'level', 'playing_style'
  ]);
  var comparisonFields = ['weight', 'shape', 'balance', 'feel', 'style', 'level', 'face', 'core', 'surface', 'summary'];

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = String(text);
    return node;
  }

  function textValue(value) {
    return typeof value === 'string' ? value.trim() : '';
  }

  function normalizeBalance(value) {
    var normalized = textValue(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('pt-PT');
    if (!normalized) return null;
    // Only the three owner-approved labels are valid. Composite/legacy
    // wording must be resolved in the data build before the ficha mounts.
    if (normalized === 'baixo') return 'Baixo';
    if (normalized === 'medio') return 'Médio';
    if (normalized === 'alto') return 'Alto';
    return null;
  }

  function comparisonValue(product, field) {
    var value = product && product.specs && product.specs[field];
    if (value && typeof value === 'object') value = value.value;
    if (field === 'balance') return normalizeBalance(value);
    return value === null || value === undefined || String(value).trim() === '' ? null : String(value);
  }

  function comparisonReady(product) {
    return comparisonFields.every(function (field) { return comparisonValue(product, field) !== null; });
  }

  function previewAllowed(config) {
    if (!config) return false;
    if (config.draft === false) return !!(config.audit && config.audit.publicCatalogComplete === true);
    try {
      if (new URL(location.href).searchParams.get('preview_theme_id') === DRAFT_THEME_ID) return true;
    } catch (_) { /* Ignore malformed location values. */ }
    var theme = window.Shopify && window.Shopify.theme;
    if (theme) return String(theme.id) === DRAFT_THEME_ID && theme.role !== 'main';
    return ['localhost', '127.0.0.1', '[::1]'].indexOf(location.hostname) !== -1;
  }

  function handleFrom(value) {
    try {
      var path = new URL(value, location.origin).pathname;
      var match = path.match(/(?:^|\/)products\/([^/]+)\/?$/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (_) { return ''; }
  }

  function sourceUrl(value) {
    if (!textValue(value)) return null;
    try {
      var url = new URL(value);
      return url.protocol === 'https:' && !url.username && !url.password ? url.href : null;
    } catch (_) { return null; }
  }

  function readConfig() {
    var node = document.getElementById('spc-data');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (_) { return null; }
  }

  function sourceMap(facts) {
    var sources = new Map();
    (Array.isArray(facts.sources) ? facts.sources : []).forEach(function (source) {
      if (!source || !source.id) return;
      // Owner-confirmed values have no external URL. Keep their provenance in
      // the table and render it as a label rather than dropping the row.
      if (source.access === 'user_confirmation' || source.access === 'derived') {
        sources.set(String(source.id), source);
        return;
      }
      if (!sourceUrl(source.url)) return;
      // Secondary specialist pages and explicit official search records are
      // allowed only when the catalog marks them as such. Their provenance is
      // shown in the product block; they are never silently presented as a
      // Strong Padel measurement.
      if (source.access !== 'page' && source.access !== 'official_catalog' &&
          source.access !== 'secondary_page' && source.access !== 'official_search_excerpt') return;
      sources.set(String(source.id), source);
    });
    return sources;
  }

  function documentedRows(product, sources) {
    if (product.productFacts.comparisonComplete === true) {
      var mapping = [['weight','Peso',['weight','weight_range_g','weight_g']],['shape','Formato',['shape']],['balance','Balanço',['balance_category']],['feel','Toque',['feel']],['style','Estilo de jogo',['playing_style']],['level','Nível recomendado',['level']],['face','Faces',['face_material']],['core','Núcleo',['core_material']],['surface','Superfície',['surface']]];
      return mapping.map(function (entry) {
        var original = entry[2].map(function (key) { return product.technicalRows.find(function (row) { return row.key === key; }); }).find(Boolean);
        return Object.assign({}, original, { key: entry[2][0], label: entry[1], displayValue: product.specs[entry[0]], category:'spec' });
      });
    }
    var seen = new Set();
    return (Array.isArray(product.technicalRows) ? product.technicalRows : []).filter(function (row) {
      if (!row || !textValue(row.key) || !textValue(row.label) || !textValue(row.displayValue)) return false;
      // The owner requested a categorical balance only. Keep numeric balance
      // in the JSON audit trail, but never render it in the public product block.
      if (row.key === 'balance_mm') return false;
      if (row.category !== 'spec' && row.category !== 'extra') return false;
      if (!Array.isArray(row.source_ids) || !row.source_ids.length) return false;
      if (!row.source_ids.every(function (id) { return sources.has(String(id)); })) return false;
      if (seen.has(row.key)) return false;
      seen.add(row.key);
      return true;
    }).map(function (row) {
      if (row.key !== 'balance_category') return row;
      var balance = normalizeBalance(row.value !== undefined ? row.value : row.displayValue);
      if (!balance) return null;
      // Do not mutate the catalog object: only the rendered copy is normalized.
      return Object.assign({}, row, { value: balance, displayValue: balance });
    }).filter(Boolean);
  }

  function findDescription(product) {
    var main = document.querySelector('main, #MainContent');
    if (!main) return null;
    var candidates = Array.from(main.querySelectorAll('.product__description')).filter(function (node) {
      if (node.closest('dialog, quick-add-modal, product-recommendations, complementary-products, [data-sps-ui]')) return false;
      if (node.hidden && (!mounted || mounted.original !== node)) return false;
      var info = node.closest('product-info');
      if (info) {
        var url = info.getAttribute('data-url');
        if (url && handleFrom(url) !== product.handle) return false;
        var productId = info.getAttribute('data-product-id');
        if (productId && product.id && String(productId) !== String(product.id)) return false;
      }
      return true;
    });
    // Ambiguous main-product markup must retain the original content.
    return candidates.length === 1 ? candidates[0] : null;
  }

  function details(label, className) {
    var block = el('details', 'sps-details' + (className ? ' ' + className : ''));
    block.appendChild(el('summary', 'sps-summary', label));
    return block;
  }

  function tableFor(rows, captionText) {
    var table = el('table', 'sps-table');
    table.appendChild(el('caption', 'sps-visually-hidden', captionText));
    var body = el('tbody');
    rows.forEach(function (row) {
      var tr = el('tr');
      tr.dataset.spsKey = row.key;
      var label = el('th', '', row.label);
      label.scope = 'row';
      tr.appendChild(label);
      // displayValue is already formatted by the official-data adapter, including units.
      var value = el('td', '', row.displayValue);
      if (textValue(row.note)) value.appendChild(el('span', 'sps-visually-hidden', ' Nota disponível em Fontes e notas por característica.'));
      tr.appendChild(value);
      body.appendChild(tr);
    });
    table.appendChild(body);
    return table;
  }

  function sourceLinks(row, sources) {
    var group = el('span', 'sps-source-links');
    row.source_ids.forEach(function (id, index) {
      var source = sources.get(String(id));
      if (!source) return;
      if (index) group.appendChild(document.createTextNode(' · '));
      var label = textValue(source.label) || textValue(source.title) || 'Fonte oficial';
      if (source.access === 'user_confirmation' || source.access === 'derived') {
        group.appendChild(el('span', 'sps-source-label', label));
        return;
      }
      var link = el('a', 'sps-source-link', label);
      link.href = sourceUrl(source.url);
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.appendChild(el('span', 'sps-visually-hidden', ' (abre num novo separador)'));
      group.appendChild(link);
    });
    return group;
  }

  function formatDate(value) {
    var date = textValue(value).match(/^(\d{4})-(\d{2})-(\d{2})(?:$|T)/);
    return date ? date[3] + '/' + date[2] + '/' + date[1] : '09/09/2026';
  }

  function build(product, rows, sources) {
    var facts = product.productFacts;
    var block = el('section', 'sps-product-specs');
    block.setAttribute('data-sps-ui', '');
    block.setAttribute('data-spc-ui', '');
    block.dataset.spsHandle = product.handle;
    block.setAttribute('aria-labelledby', 'sps-heading');
    var header = el('header', 'sps-header');
    header.appendChild(el('p', 'sps-eyebrow', 'STRONG PADEL · FICHA TÉCNICA'));
    var heading = el('h2', 'sps-heading', 'Conhece a raquete');
    heading.id = 'sps-heading';
    header.appendChild(heading);
    header.appendChild(el('p', 'sps-intro', 'Características das fontes indicadas e confirmações da Strong Padel'));
    header.appendChild(el('p', 'sps-date', 'Recolha: ' + formatDate(facts.checked_at)));
    block.appendChild(header);

    var identity = facts.identity || {};
    var identityParts = [];
    if (textValue(identity.official_name)) identityParts.push(identity.official_name);
    if (identity.official_reference !== null && identity.official_reference !== undefined && String(identity.official_reference).trim()) {
      identityParts.push('Ref. ' + String(identity.official_reference));
    }
    if (identity.official_year !== null && identity.official_year !== undefined && String(identity.official_year).trim()) {
      identityParts.push('Modelo ' + String(identity.official_year));
    }
    if (identityParts.length && !facts.comparisonComplete) block.appendChild(el('p', 'sps-identity', identityParts.join(' · ')));

    var primary = facts.comparisonComplete ? rows : rows.filter(function (row) { return row.category === 'spec' && primaryKeys.has(row.key); });
    var extra = rows.filter(function (row) { return primary.indexOf(row) === -1; });
    // A partial but documented model can still show its available specifications.
    if (!primary.length) { primary = extra; extra = []; }
    block.appendChild(tableFor(primary, 'Características técnicas do modelo'));
    if (extra.length) {
      var more = details('Mais características e tecnologias (' + extra.length + ')', 'sps-more');
      more.appendChild(tableFor(extra, 'Outras características técnicas do modelo'));
      block.appendChild(more);
    }

    if (rows.some(function (row) { return row.qualitative === true; })) {
      block.appendChild(el('p', 'sps-qualitative', 'Toque, nível e estilo de jogo são orientações qualitativas das fontes indicadas e da Strong Padel.'));
    }

    var warnings = (Array.isArray(facts.warnings) ? facts.warnings : []).map(textValue).filter(Boolean);
    if (warnings.length && !facts.comparisonComplete) {
      var warningList = el('ul', 'sps-warnings');
      Array.from(new Set(warnings)).forEach(function (warning) { warningList.appendChild(el('li', '', warning)); });
      block.appendChild(warningList);
    }

    var provenance = details('Fontes e notas por característica', 'sps-provenance');
    var hasSecondary = Array.from(sources.values()).some(function (source) { return source.access === 'secondary_page'; });
    var hasOfficialExcerpt = Array.from(sources.values()).some(function (source) { return source.access === 'official_search_excerpt'; });
    var provenanceIntro = hasSecondary || hasOfficialExcerpt
      ? 'Informação recolhida em fichas da marca e fontes especializadas em ' + formatDate(facts.checked_at) + '. As fontes secundárias e os registos oficiais indexados estão identificados nas notas; as ligações abrem num novo separador.'
      : 'Informação recolhida em fontes oficiais da marca em ' + formatDate(facts.checked_at) + '. As ligações abrem num novo separador.';
    provenance.appendChild(el('p', 'sps-detail-intro', provenanceIntro));
    var sourceList = el('dl', 'sps-source-list');
    rows.forEach(function (row) {
      sourceList.appendChild(el('dt', '', row.label));
      var entry = el('dd');
      if (textValue(row.note)) entry.appendChild(el('p', 'sps-field-note', row.note));
      entry.appendChild(sourceLinks(row, sources));
      sourceList.appendChild(entry);
    });
    provenance.appendChild(sourceList);
    block.appendChild(provenance);
    if (readConfig().draft) block.appendChild(el('p', 'sps-preview-note', 'Pré-visualização da ficha técnica.'));
    return block;
  }

  function unmount() {
    if (!mounted) return false;
    var original = mounted.original;
    mounted.block.remove();
    if (mounted.hidden === null) original.removeAttribute('hidden');
    else original.setAttribute('hidden', mounted.hidden);
    if (mounted.marker === null) original.removeAttribute('data-sps-original');
    else original.setAttribute('data-sps-original', mounted.marker);
    mounted = null;
    return true;
  }

  function render() {
    pending = 0;
    if (!enabled) return;
    var config = readConfig();
    if (!previewAllowed(config)) { unmount(); return; }
    if (config.audit && config.audit.publicCatalogComplete !== true) { unmount(); return; }
    var handle = handleFrom(location.href);
    var matches = (Array.isArray(config.products) ? config.products : []).filter(function (product) {
      return product && product.handle === handle;
    });
    if (!handle || matches.length !== 1) { unmount(); return; }
    var product = matches[0];
    var facts = product.productFacts;
    // Keep product fichas aligned with the strict comparator: an incomplete
    // model receives no replacement block until all compared values exist.
    if (!comparisonReady(product)) { unmount(); return; }
    if (!facts || facts.eligible !== true ||
        (facts.status !== 'documented' && facts.status !== 'documented_secondary')) { unmount(); return; }
    var sources = sourceMap(facts);
    var rows = documentedRows(product, sources);
    if (!rows.length) { unmount(); return; }
    if (mounted && (mounted.handle !== handle || !mounted.original.isConnected || !mounted.block.isConnected)) unmount();
    if (mounted) return;
    var original = findDescription(product);
    if (!original || !original.parentNode) return;
    // Construct everything before hiding the original: malformed data fails open.
    var block = build(product, rows, sources);
    var hidden = original.getAttribute('hidden');
    var marker = original.getAttribute('data-sps-original');
    original.parentNode.insertBefore(block, original);
    original.setAttribute('data-sps-original', '');
    original.hidden = true;
    mounted = { original: original, block: block, handle: handle, hidden: hidden, marker: marker };
  }

  function schedule() {
    if (enabled && !pending) pending = window.setTimeout(render, 80);
  }

  function init() {
    enabled = true;
    render();
    if (!observer && document.body) {
      observer = new MutationObserver(function (mutations) {
        if (!enabled) return;
        var changed = mutations.some(function (mutation) {
          if (mutation.target.nodeType === 1 && mutation.target.closest('[data-sps-ui]')) return false;
          return Array.from(mutation.addedNodes).concat(Array.from(mutation.removedNodes)).some(function (node) {
            if (node.nodeType !== 1 || node.hasAttribute('data-sps-ui')) return false;
            return node.matches('.product__description, product-info, #spc-data') || !!node.querySelector('.product__description, product-info, #spc-data');
          });
        });
        if (changed) schedule();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  window.StrongProductSpecs = {
    init: init,
    restore: function () {
      enabled = false;
      window.clearTimeout(pending);
      pending = 0;
      return unmount();
    }
  };
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('spc:data-ready', schedule);
  window.addEventListener('popstate', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
}());
